'POCsv'.output()
'PURCHASE ORDER'.title()
'PO'.datatype()

'Header'.section({pageHeading: true})
'purchaseOrderNumber'.field({caption: "Order Number"})
'orderDate'.field({caption: "Date"})
'deliverTo'.field()
'ourContactDetails'.field({caption: ''})
'notesForSupplier'.field({caption: 'Notes'})
'supplier'.field({caption: "Supplier"})
'supplierFullAddress'.field({caption: ""})
'supplierReference'.field()
'costIncTaxFXWithCurrency'.field({caption: "Order Amount (Inc Tax)"})

'Lines'.manifest()
'POLine'.datatype()
'descriptionAndSKU'.field()
'supplierSku'.field()
'quantity'.field({caption: "Qty"})
'unitCostExclTaxFX'.field({caption: "Price"})
'taxPct'.field({caption: "Tax %"})
'unitCostIncTaxFXRounded'.field({caption: "Price (Inc Tax)"})
'lineCostIncTaxFX'.field({caption: "Amount"})
